import * as yup from 'yup'

{
  /* ひとまず英語にした sakao  */
}
export const inputSchema = yup
  .string()
  .max(50, '50_characters_warning')
  .required('label_enter_name')
